import type { GroupPreviewType } from 'models';
import { useCallback } from 'react';
import { Icon } from 'ui';

export const useGetGroupPreviewIcon = () =>
  useCallback(({ groupType }: { groupType: GroupPreviewType }) => {
    switch (groupType) {
      case 'association':
      case 'denomination':
      case 'district':
      case 'jurisdiction':
      case 'region':
      case 'state_convention':
        return <Icon icon="folder-line" />;
      case 'organization':
        return <Icon icon="church-line" />;
      case 'private_label_app':
        return <Icon icon="cellphone-line" />;
    }
  }, []);
